import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import DefaultLayout from '../../DefaultLayout/DefaultLayout';
import { AppContext } from '../../../App.context';
import StartCheckin from './Texts/StartCheckin';
import LegalDocuments from './Texts/LegalDocuments';
import EndCheckin from './Texts/EndCheckin';
import LanguageSelector from 'Components/common/LanguageSelectorNew/languageSelector';
import styles from './DefaultInfoTexts.styles';
import useDefaultInfoTextsHook from './DefaultInfoTexts.hook';

export default function DefaultInfoTexts() {
  const location = useLocation();
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const { state, actions } = useDefaultInfoTextsHook();

  const renderContent = () => {
    if (location.pathname.includes('/informationTexts/startCheckin')) {
      return <StartCheckin state={state} actions={actions} />;
    }

    if (location.pathname.includes('/informationTexts/legalDocuments')) {
      return <LegalDocuments state={state} actions={actions} />;
    }

    if (location.pathname.includes('/informationTexts/endCheckin')) {
      return <EndCheckin state={state} actions={actions} />;
    }

    return <div>{translate('notFound')}</div>;
  };

  return (
    <DefaultLayout
      contentHeader={
        <div style={styles.header}>
          <div style={styles.langSelectorContainer}>
            <LanguageSelector onChange={actions.setSelectedLanguage} />
            <div>{translate('informationTexts.langSelectorText')}</div>
          </div>
        </div>
      }
    >
      {renderContent()}
    </DefaultLayout>
  );
}
